import { StateContext } from '@ngxs/store';
import { patch, updateItem } from '@ngxs/store/operators';
import { Page } from 'src/modules/shared/model/page';
import { ExhibitionStateModel } from '../exhibition.state';
import { RevertPageFromGallery } from '../exhibition.state.actions';

export const revertPageFromGallery = (ctx: StateContext<ExhibitionStateModel>, action: RevertPageFromGallery) => {
    const state = ctx.getState();
    ctx.setState(
        patch({
            selectedSection: 0,
            pages: updateItem<Page>(
                (item) => item?.page_number === state.selectedPage && item?.language === state.selectedLanguage,
                patch({ gallery: false, sections: action.payload.sections })
            )
        })
    );
};
